<template>
  <div class="select-day-presentation-title">
    {{ presentationString }}
  </div>
</template>

<script>
import { WELCOME_SET } from '@/config/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'SelectDayPresentation',

  props: {
    params: {
      type: Object,
      required: true,
    },

    selectedDayParams: {
      type: Object,
      required: true,
    },

    isExpressDeliverySelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('marketing', ['isExpressDeliveryVisible']),

    isCurrentDate () {
      return this.$date().format('YYYY-MM-DD') === this.params.format('YYYY-MM-DD')
    },
    isTomorrow () {
      return this.$date().add(1, 'day').format('YYYY-MM-DD') === this.params.format('YYYY-MM-DD')
    },
    presentationString () {
      if (this.isExpressDeliveryVisible && this.isExpressDeliverySelected) {
        return 'Доставим сегодня за 2 часа'
      }

      let datePresentation
      if (this.isCurrentDate) {
        datePresentation = 'сегодня'
      } else if (this.isTomorrow) {
        datePresentation = 'завтра'
      } else {
        datePresentation = `${this.params.format('D MMM')}`
      }

      const stringPrefix = this.$route.params.goal === WELCOME_SET ? '' : 'Доставим '
      return `${stringPrefix}${datePresentation} с ${this.selectedDayParams.timeFrom}`
    },
  },
}
</script>

<style lang="scss">
  $prefix: 'select-day-presentation-title';

  .#{$prefix} {
    padding-left: 0.16rem;

    &:first-letter {
      text-transform: capitalize;
    }
  }

</style>
